export const REFRESH_TOP_OFFERS_UPDATE_TOKEN = 'REFRESH_TOP_OFFERS_UPDATE_TOKEN';
export const RESET_TOP_OFFERS_DATA = 'RESET_TOP_OFFERS_DATA';
export const FETCH_TOP_OFFERS = 'FETCH_TOP_OFFERS';
export const FETCH_TOP_OFFERS_ASSETS = 'FETCH_TOP_OFFERS_ASSETS';
